import { render, staticRenderFns } from "./FeaturesSection.vue?vue&type=template&id=54dcd4bd&"
import script from "./FeaturesSection.vue?vue&type=script&lang=js&"
export * from "./FeaturesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54dcd4bd')) {
      api.createRecord('54dcd4bd', component.options)
    } else {
      api.reload('54dcd4bd', component.options)
    }
    module.hot.accept("./FeaturesSection.vue?vue&type=template&id=54dcd4bd&", function () {
      api.rerender('54dcd4bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/realEstate/sections/FeaturesSection.vue"
export default component.exports